// extracted by mini-css-extract-plugin
export default {"heading":"Sj-z","list":"Tj-z"};